import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'common/utils/browserHistory';
import _ from 'lodash';
import {
  tracker,
} from '@unite-us/client-utils';

import DetailView from 'src/components/Dashboard/components/DetailView';
import IndexDetailView from 'src/components/Dashboard/components/IndexDetailView';
import ProcessedIndex from 'src/components/Dashboard/components/AssistanceRequests/ProcessedIndex';
import { fetchDashboardAssistanceRequests } from 'actions/AssistanceRequest/Group';
import fetchProvidersUserCore from 'src/actions/UserProvider/fetchProvidersUser';
import { getDataOfPage, isDataValid } from 'src/components/Dashboard/utils/dataHelpers';
import AssistanceRequestDetail from 'src/components/AssistanceRequests/components/AssistanceRequestDetail';
import callOrLog from 'src/common/utils/callOrLog';
import { careCoordinatorsFilter, serviceTypesFilter } from 'src/components/Dashboard/utils/filter';
import { noneAssignedOption } from 'src/components/Dashboard/utils/filterDefaults';
import { DASHBOARD_EVENTS, DASHBOARD_VIEWS } from 'common/utils/EventTracker/utils/eventConstants';
import { getGroupUsersOptions } from 'src/components/Groups/Users/utils';
import labelCustomization from 'src/common/utils/Customization/labels';
import defaultLabels from 'src/constants/labels';
import { loadDashboardSortingConfiguration } from 'src/components/Dashboard/utils/userSortingHandler';
import { createSortChangeHandler } from 'src/components/Dashboard/utils/sortHelpers';
import {
  getInitialDashboardPage,
  refetchCurrentDashboardPage,
  syncDashboardPageFromProps,
} from 'src/components/Dashboard/utils/pageRestore';

export class Processed extends Component {
  constructor(props) {
    super(props);
    const sortObj = loadDashboardSortingConfiguration(browserHistory.getCurrentLocation().pathname);

    this.state = {
      activeUsersInGroup: [],
      page: getInitialDashboardPage(props, 'assistanceRequests'),
      sidx: sortObj?.column.sortBy || 'updated_at',
      sord: sortObj?.sortDirection || 'desc',
      filters: {
        service_types: _.get(props, 'filters.service_types', []),
      },
    };

    this.fetch = this.fetch.bind(this);
    this.fetchGroupsUsers = this.fetchGroupsUsers.bind(this);
    this.onCellClick = this.onCellClick.bind(this);
    this.onFiltersChange = this.onFiltersChange.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.onPrevClick = this.onPrevClick.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
  }

  componentDidMount() {
    this.fetch(this.state.page);
    this.props.fetchProvidersUserCore({
      providers: this.props.groupId,
    }).then((response) => {
      if (response) {
        const { employees: activeUsersInGroup } = response;
        this.setState({ activeUsersInGroup });
      }
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    syncDashboardPageFromProps(this, nextProps, 'assistanceRequests');

    if (!this.props.refetch && nextProps.refetch) {
      refetchCurrentDashboardPage(this, 'assistanceRequests', nextProps);
    }
  }

  componentDidUpdate(prevProps) {
    if (_.get(prevProps, 'params.id') && !_.get(this.props, 'params.id')) {
      refetchCurrentDashboardPage(this, 'assistanceRequests');
    }
  }

  onSortChange = createSortChangeHandler(this);

  onCellClick(row) {
    const pagedData = getDataOfPage(this.props.assistanceRequests, this.state.page);
    const assistanceRequest = pagedData.data[row];

    callOrLog(() => this.context.eventTracker(DASHBOARD_EVENTS.processedAssistanceRequestsRow, {
      view: DASHBOARD_VIEWS.processedAssistanceRequests,
      processed_at: _.get(assistanceRequest, 'converted_to[0].created_at'),
    }, { assistanceRequest }));

    browserHistory.push({
      pathname: `/dashboard/assistance-requests/processed/${assistanceRequest.id}`,
      state: { prevLocation: browserHistory.getCurrentLocation().pathname },
    });
  }

  onFiltersChange(key, activeFilters, callbacks) {
    let newFilters = activeFilters;
    if (_.isEqual(key, 'care_coordinator_users')) {
      newFilters = careCoordinatorsFilter(activeFilters, callbacks);
    }
    this.setState({
      page: 1,
      filters: _.assign({}, this.state.filters, { [key]: newFilters }),
    }, () => {
      callOrLog(() => {
        const filters = tracker.buildDashboardFilterPayload(this.state, this.props);
        this.context.eventTracker(DASHBOARD_EVENTS.processedAssistanceRequestsFilter, filters);
      });

      this.fetch();
    });
  }

  onNextClick() {
    const page = this.state.page + 1;
    this.fetch(page);
  }

  onPrevClick() {
    const page = this.state.page - 1;
    this.fetch(page);
  }

  fetch(page = 1) {
    const { sidx, sord, filters } = this.state;
    const formattedFilters = _.clone(filters);

    this.setState({ page });
    this.props.fetchDashboardAssistanceRequests(
      this.props.groupId,
      {
        target: 'processedAssistanceRequests',
        sidx,
        sord,
        page,
        filters: {
          ...formattedFilters,
          statuses: ['processed'],
        },
      },
    );
  }

  shouldFetch(page) {
    if (isDataValid(this.props.assistanceRequests, page)) {
      this.setState({ page });
    } else {
      this.fetch(page);
    }
  }

  fetchGroupsUsers(search = '') {
    const { groupId } = this.props;
    return this.props.fetchProvidersUserCore({
      providers: groupId,
      options: {
        text: search,
        licensed: false,
      },
    }).then((response) => {
      if (response) {
        const { employees: activeUsersInGroup } = response;
        if (search === '') {
          return _.concat(
            [noneAssignedOption(this.state)],
            getGroupUsersOptions(activeUsersInGroup, this.state),
          );
        }

        return getGroupUsersOptions(activeUsersInGroup, this.state);
      }

      return [];
    });
  }

  render() {
    const {
      activeUsersInGroup,
      page,
      sidx,
      sord,
    } = this.state;
    const {
      assistanceRequests,
      isFetching,
      params,
      serviceTypes,
      labels,
    } = this.props;

    let filters = [
      serviceTypesFilter(serviceTypes, this.state.filters.service_types),
    ];
    filters = _.concat(filters, [
      {
        key: 'care_coordinator_users',
        name: labels.CareCoordinator,
        pluralName: `${labels.CareCoordinator}s`,
        options: _.concat(
          [noneAssignedOption(this.state)],
          getGroupUsersOptions(activeUsersInGroup, this.state),
        ),
      }]);

    const newParams = { ...params, assistance_request_id: params.id };
    const pagedData = getDataOfPage(assistanceRequests, page);
    const sortConfig = {
      sidx: this.state.sidx,
      sord: this.state.sord,
    };

    const detailView = (
      <DetailView
        innerContentView={
          <AssistanceRequestDetail subjectType="referral" params={newParams} />
        }
        hideMessageCenterButton
      />
    );

    return (
      <IndexDetailView
        data={pagedData.data}
        DetailView={detailView}
        IndexView={ProcessedIndex}
        isFetching={isFetching || pagedData.invalidated}
        onCellClick={this.onCellClick}
        onNextClick={this.onNextClick}
        onPrevClick={this.onPrevClick}
        paging={pagedData.paging}
        params={params}
        filters={_.sortBy(filters, 'name')}
        initialSort={{ [sidx]: sord }}
        onFiltersChange={this.onFiltersChange}
        fetchGroupsUsers={this.fetchGroupsUsers}
        sortConfig={sortConfig}
        setSort={this.onSortChange}
      />
    );
  }
}

Processed.propTypes = {
  assistanceRequests: PropTypes.shape({
    data: PropTypes.array,
    currentPage: PropTypes.number,
  }).isRequired,
  fetchDashboardAssistanceRequests: PropTypes.func.isRequired,
  fetchProvidersUserCore: PropTypes.func.isRequired,
  groupId: PropTypes.string.isRequired,
  isFetching: PropTypes.bool.isRequired,
  params: PropTypes.object.isRequired,
  refetch: PropTypes.bool.isRequired,
  serviceTypes: PropTypes.array.isRequired,
  labels: PropTypes.object,
};

Processed.defaultProps = {
  labels: defaultLabels,
};

Processed.contextTypes = {
  eventTracker: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const assistanceRequests = _.get(state, 'dashboard.processedAssistanceRequests', {});
  const userId = _.get(state, 'user.id');
  const groupId = _.get(state, 'session.groupId');
  const isFetching = _.get(state, 'dashboard.processedAssistanceRequests.isFetching', false);
  const refetch = _.get(state, 'dashboard.refetch');
  const token = _.get(state, 'session.token', '');
  const isCC = _.wget(state, 'session.isCoordinationGroup', false);
  const serviceTypesPath = isCC ? 'serviceTypes.network' : 'serviceTypes.allPrograms';
  const serviceTypes = _.wget(state, serviceTypesPath, []);

  return {
    assistanceRequests,
    userId,
    groupId,
    isFetching,
    refetch,
    token,
    serviceTypes,
    labels: labelCustomization(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({ fetchDashboardAssistanceRequests, fetchProvidersUserCore }, dispatch),
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Processed);
